import curry from "../../lib/core/functional/curry";

const renderModule = curry(function renderModule({ h, Fragment }, _context, {}, _altLoader) {
    function SectionWrapper({ children }) {
        return <span class="menu-parent-item">{children}</span>;
    }

    function NonSectionWrapper({ children, ...props }) {
        const { url, title, classes } = props;

        return (
            <div class={classes}>
                <a class="link" href={url} title={title}>
                    {children}
                </a>
            </div>
        );
    }

    function SubMenu(props) {
        const { entries } = props;
        if (entries && entries.length > 0) {
            return (
                <ul class="mdc-list mainmenu-sub">
                    {entries.map((entry, index) => (
                        <Entry {...entry} key={index} />
                    ))}
                </ul>
            );
        } else {
            return null;
        }
    }

    function entryMapper(entry, index) {
        return <Entry {...entry} key={index} />;
    }

    function Entry(props, _index) {
        const { title, ico, submenu, logo, thumb, id, show_divider } = props;
        const isSection = submenu && submenu.length > 0;
        const Wrapper = isSection ? SectionWrapper : NonSectionWrapper;

        return (
            <li
                class={`main-menu-item main-menu-item--${id}${isSection ? " section" : ""}${
                    show_divider ? " divider" : ""
                }`}
            >
                <Wrapper {...props}>
                    {ico && <i class={`ico ${ico}`}></i>}
                    {thumb && <img height="24" src={`${thumb}`} class="user-fav" />}
                    {logo && <img src={`${logo}`} class="item-link--logo" height="25" />}
                    <span class="item-link">{title}</span>
                    <SubMenu entries={submenu} />
                </Wrapper>
            </li>
        );
    }

    function Module(props) {
        const { entries } = props;
        return <Fragment>{entries.map(entryMapper)}</Fragment>;
    }

    return Module;
});

export default function sideMenu({ preact }) {
    return renderModule(preact);
}
